import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../store/useAuthStore';

export function ProtectedRoute({ permission, children }) {
  const { user } = useAuthStore();

  if (!permission) return children;

  if (!user?.permissions?.includes(permission)) {
    return <Navigate to="/casos" replace />;
  }

  return children;
}
